import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-template w-full h-full" }
const _hoisted_2 = { class: "col content-transparent w-full h-full" }

import EsSubMenu from "@/components/share/esSubMenu.vue";
import EsAdminInstitute from "@/components/admin/esAdminInstitute.vue";
import EsMedicalPerson from "@/components/admin/esMedicalPerson.vue";
import EsPermissionSetting from "@/views/officeMain/settings/esPermissionSetting.vue";
import EsAdminFinancialGroup from "@/components/admin/esAdminFinancialGroup.vue";
import EsNotification from "@/components/admin/esNotification.vue";
import { AdminMenuEnum, SubMenu } from "@/models/subMenu.model";
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { InstituteLightResponse } from "@/apiGenerate/medserver/models/InstituteLightResponse";
import { AdminApi } from "@/apiGenerate/medserver";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { SctLanguageItem } from "@/models/share.model";
import { toastError } from "@/utils/toast-utils";
import { useToast } from 'primevue';


export default /*@__PURE__*/_defineComponent({
  __name: 'esAdmin',
  setup(__props) {

const { t } = useI18n();
const toast = useToast();
const adminApi = new AdminApi(medServerApiConfig);

const itemSelected = ref<AdminMenuEnum>(AdminMenuEnum.INSTITUTE);
const instituteList = ref<InstituteLightResponse[]>([]);

const items = ref<SubMenu[]>([
    {
        ref: AdminMenuEnum.INSTITUTE,
        label: t('admin.subMenu.institute'),
        icon: 'building-2',
        pathIcon: 'adminIcons',
        displaySeparator: false,
        visible: true,
        command: () => {
            itemSelected.value = AdminMenuEnum.INSTITUTE;
        }
    },
    {
        ref: AdminMenuEnum.MEDICAL_PERSON,
        label: t('admin.subMenu.medicalPerson'),
        icon: 'person',
        pathIcon: 'adminIcons',
        displaySeparator: false,
        visible: true,
        command: () => {
            itemSelected.value = AdminMenuEnum.MEDICAL_PERSON;
        }
    },
    {
        ref: AdminMenuEnum.PERMISSIONS,
        label: t('admin.subMenu.permissions'),
        icon: 'lock',
        pathIcon: 'settings',
        displaySeparator: false,
        visible: true,
        command: () => {
            itemSelected.value = AdminMenuEnum.PERMISSIONS;
        }
    },
    {
        ref: AdminMenuEnum.FINANCIAL_GROUP,
        label: t('admin.subMenu.financialGroups'),
        icon: 'creditcard',
        pathIcon: 'menuIcons',
        displaySeparator: false,
        visible: true,
        command: () => {
            itemSelected.value = AdminMenuEnum.FINANCIAL_GROUP;
        }
    },
    {
        ref: AdminMenuEnum.NOTIFICATION,
        label: t('admin.subMenu.notifications'),
        icon: 'bell',
        pathIcon: 'adminIcons',
        displaySeparator: false,
        visible: true,
        command: () => {
            itemSelected.value = AdminMenuEnum.NOTIFICATION;
        }
    },
]);

const getAllInstitutes = () => {
    adminApi.searchInstitute({ type: null }).then((response: InstituteLightResponse[]) => {
        instituteList.value = response.sort((a, b) =>
            a.name.localeCompare(b.name, SctLanguageItem.FrFr, { sensitivity: 'base' })
        );
    }).catch(() => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t('error.DEFAULT')
        });
    });
}

onMounted(async () => {
    await getAllInstitutes();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EsSubMenu, {
      "item-selected": itemSelected.value,
      "sub-menu-title": _unref(t)('admin.subMenu.title'),
      items: items.value,
      "path-icon": 'adminIcons'
    }, null, 8, ["item-selected", "sub-menu-title", "items"]),
    _createElementVNode("div", _hoisted_2, [
      (itemSelected.value === _unref(AdminMenuEnum).INSTITUTE)
        ? (_openBlock(), _createBlock(EsAdminInstitute, { key: 0 }))
        : _createCommentVNode("", true),
      (itemSelected.value === _unref(AdminMenuEnum).MEDICAL_PERSON)
        ? (_openBlock(), _createBlock(EsMedicalPerson, { key: 1 }))
        : _createCommentVNode("", true),
      (itemSelected.value === _unref(AdminMenuEnum).PERMISSIONS)
        ? (_openBlock(), _createBlock(EsPermissionSetting, {
            key: 2,
            class: "w-full",
            "admin-esk": true,
            instituteList: instituteList.value
          }, null, 8, ["instituteList"]))
        : _createCommentVNode("", true),
      (itemSelected.value === _unref(AdminMenuEnum).FINANCIAL_GROUP)
        ? (_openBlock(), _createBlock(EsAdminFinancialGroup, {
            key: 3,
            "institute-list": instituteList.value
          }, null, 8, ["institute-list"]))
        : _createCommentVNode("", true),
      (itemSelected.value === _unref(AdminMenuEnum).NOTIFICATION)
        ? (_openBlock(), _createBlock(EsNotification, { key: 4 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})